import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import AddCircle from '@material-ui/icons/AddCircle';
import { Button, Grid } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../functions/server';
import Items from './items';
import ReadCookie from '../../functions/readcookies';
import Loading from '../loading';

const styles = theme => ({
  form: {
    display: 'flex', flexDirection: 'column',
    margin: 'auto', width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2, minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class View extends React.Component {
  state = {
    open: false, fullWidth: true,
    maxWidth: 'lg', spareOption: [],
    items: [], duplicate: []
  };

  getBranch() {
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      let branchId;
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
      }
      return branchId;
    }
  }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){ dd = '0' + dd; }
    if(mm < 10){ mm = '0' + mm; }
    today = yyyy+'-'+mm+'-'+dd;
    return today;
  }

  getPartcode() {
    if (!this.props.menuPermission.add) {
      alert('You Are Not Allow To Add!!!');
      return;
    }
    let context = this;
    let branch = this.getBranch();
    let date = this.getToday();
    context.setState({ load: true, message: 'Getting Spares!!!' })
    $.ajax({
      type: 'POST',
      data: { 'branch': branch, 'dates': date },
      url: Server() + 'stockaudit/get.php',
      success: function(data) {
        console.log(data);
        context.setState({ date: date, load: false })
        try {
          data = JSON.parse(data);
          context.setItem(data);
        } catch (e) {
          alert('Try Again!!!');
        }
      },
      error: function(e) {
        console.log(e);
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  setItem(data) {
    let context = this;
    var x = [];
    data.map((y) => {
        let key = y.partno+'->'+y.name+'->'+y.brand_id+'->'+y.brand;
        x.push({key: key, text: key, value: y.partno});
    });
    try {
      context.setState({ spareOption: x, allSpares: data, open: true });
    } catch (e) {}
  }

  handleClose = () => { this.setState({ open: false, items: [] }); };

  handleChange = name => event => { this.setState({ [name]: event.target.value }); };

  addItem = () => {
    if (this.state.date == undefined || this.state.date == null) {
      alert('Select Date');
      return;
    }
    let items = this.state.items;
    let id = items.length;
    items.push({id: id, date: this.state.date, color: 'white'});
    this.setState({ items });
  }

  remove(id) {
    let items = this.state.items;
    let duplicate = this.state.duplicate;
    let item = [];
    let newduplicate = [];
    items.map((x) => {
      if (x.id == id) {
        duplicate.map((c) => {
          if (c.id == x.id) { }
          else { newduplicate.push(c); }
        })
      }
      else { item.push(x); }
    })
    let i = 0;
    item.map((x) => { x.id = i++; })
    this.setState({ items: item, duplicate: newduplicate })
  }

  updateItem(value, brand, id, dropdownvalue) {
    let context = this;
    let data = this.state.allSpares;
    let partno, brand_id, partname, brand_name, closing, branchStock, branch_stock_id;
    data.map((z) => {
      if (z.partno == value && z.brand_id == brand) {
        partno = z.partno; brand_id = z.brand_id;
        partname = z.name; brand_name = z.brand;
        closing = z.closing; branchStock = z.branch_stock;
        branch_stock_id = z.branch_stock_id;
        try {
          branchStock = Number(z.branch_stock);
        } catch (e) {
          branchStock = 'add';
        }
      }
    })
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == id) {
        items[i]['dropdownvalue'] = dropdownvalue;
        items[i]['partno'] = partno;
        items[i]['brand_id'] = brand_id;
        items[i]['brand_name'] = brand_name;
        items[i]['partname'] = partname;
        items[i]['closing'] = closing;
        items[i]['branch_stocks'] = branchStock;
        items[i]['branch_stock_id'] = branch_stock_id;
      }
    }
    this.setState({ items })
  }

  updateStock(id, type, value) {
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == id) { items[i][type] = value; }
    }
    this.setState({ items: items })
  }


  checkDuplicate(items) {
    let returnvalue = 0;
    items.map((c) => {
      let value = 0;
      items.map((v) => {
        if (c.partno == v.partno && c.brand_id == v.brand_id) {
          if (value == 0) { value = 1; }
          else { returnvalue = 1; }
        }
      })
    })
    return returnvalue;
  }

  submit() {
    let context = this;
    let items = this.state.items;
    let branch = this.getBranch();
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let value = 0;
    items.map((x) => { if (!x.partno || !x.branch_stock || !x.remark || !x.brand_id) { value = 1; } });
    if (value == 1) {
      alert('Please Remove undefined Values OR Empty Values');
      return;
    }
    let checkDuplicates = this.checkDuplicate(items);
    if (checkDuplicates == 1) {
      alert('Remove Duplicates');
      return;
    }
    items = JSON.stringify(items);
    let data1 = { 'items': items, 'branch': branch, 'userId': userId };
    context.setState({ load: true, message: 'Inserting Stock Audit!!!' })
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'stockaudit/insert.php',
      success: function(data) {
        console.log(data);
        console.log('popopppppppppppp');
        context.setState({ load: false })
        if (data == 1) {
          context.setState({ open: false, items: [] })
          context.props.getStock();
        }
        else {
          alert('Try Again!!!');
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }



  importData = (e) => {
    let context = this;
    let file = e.target.files[0];
    if (!file) {
      return;
    }
    context.setState({ load: true, message: 'File Uploading!!!' });
    var formData = new FormData();
    formData.append('file', file);
    $.ajax({
      type: 'POST', processData: false, contentType: false,
      data: formData, url: Server() + 'stockaudit/import.php',
      success: function(data) {
        console.log(data);
        console.log('kokoko');
        context.setState({ load: false });
        if (data == 1) {
          alert('Success');
        } else {
          alert('Failed');
        }
      },
      error: function(error) {
        context.setState({ load: false, });
      }
    });
  }

  render() {
    const { classes } = this.props;
    let i = 0; let lastArrayId = 0;
    let last = this.state.items;
    last.map((c) => { lastArrayId = c.id; })
    let items = this.state.items.map((x) => {
      i++;
      return (
        <Items allData={this.state.allSpares} remove={this.remove.bind(this)}
           sino={i} updateStock={this.updateStock.bind(this)} id={x.id}
           item={x} updateItem={this.updateItem.bind(this)}
           addItem={this.addItem} lastArrayId={lastArrayId}
           spareOption={this.state.spareOption} />
      )
    })
    return (
      <React.Fragment>
        <Loading load={this.state.load} message={this.state.message} />
        <Button primary onClick={this.getPartcode.bind(this)} style={{display: this.props.stockauditedit}}>Add Stock</Button>
        <input onChange={this.importData} style={{display: 'none'}} accept=".csv" id="outlined-button-file" type="file" />
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Add Stock Audit</DialogTitle>
          <DialogContent>
            { this.state.items.length >= 1 ?
              (
                <div>
                  <table id='table' width="100%">
                    <tr>
                      <th id="tableheader"><center>Sino</center></th>
                      <th id="tableheader"><center>Select Part</center></th>
                      <th id="tableheader"><center>Brand</center></th>
                      <th id="tableheader"><center>Closing Stock</center></th>
                      <th id="tableheader"><center>Branch Stock</center></th>
                      <th id="tableheader"><center>Stocks Differ</center></th>
                      <th id="tableheader"><center>Remove</center></th>
                    </tr>
                    {items}
                  </table>
                </div>
              ) : (<div></div>)
            }
            <br/>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={3}>
                <Button primary fluid onClick={this.addItem}>Add Stock</Button>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={3}>
                <Button primary fluid onClick={this.submit.bind(this)}>Submit</Button>
              </Grid.Column>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

View.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
